// See: https://www.npmjs.com/package/nanoid
const NanoId = /** @type {const} */ ({
  type: 'string',
  pattern: `^[A-Za-z0-9_-]{21}$`,
});

export default NanoId;
